import axios from 'axios';

const WEBHOOK_URL = process.env.WEBHOOK_API_URL_MAIN || 'https://jwc7v9ozxg.execute-api.us-east-2.amazonaws.com/Prod/webhook'
const headers = { 'Content-Type': 'application/json' };

/**
 * Call webhook with upload status and transaction details
 * 
 * @param {string} uploadId - Unique identifier for the upload
 * @param {string} transaction - Transaction ID or context
 * @param {string} [status] - Status of the upload or ETL process (optional)
 * @param {string} [message] - Optional message for additional context
 */

export async function callWebHook(uploadId, transaction, status='pending', message='') {
    try {
        const data = {
            uploadId: uploadId,
            status: status,
            transaction: transaction,
            message: message
        };
        const response = await axios({
            method: 'POST',
            url: WEBHOOK_URL,
            data: data,
            headers: headers
        });
        return response.data;
    } catch (error) {
        throw error; // Rethrow the error for handling elsewhere if needed
    }
}